import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import { useState } from 'react';
import {
  Card,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import { BiBuildings } from 'react-icons/bi';
import { FiActivity, FiInfo } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import StepsStatus from 'sites/admin/inmobiliario/gestionarPropiedades/common/StepsStatus';
import InfoBuilderModal from './InfoBuilderModal';
import { getImageUrl } from '../../../../../../utils/imageUrl';

const currObj = {
  1: 'USD',
  2: 'ARS'
};

const ProjectListItem = ({ project, loading, selected, setSelected }) => {
  const [openInfoModal, setOpenInfoModal] = useState(false);

  const price = project.info?.price;
  const surface = project.info?.surface;

  // * Methods
  const HandleCheckbox = () => {
    if (selected.find(prop => prop.id === project.id)) {
      setSelected(selected.filter(prop => prop.id !== project.id));
    } else {
      setSelected([
        ...selected,
        { id: project.id, title: project.title, status: project.status }
      ]);
    }
  };

  const getProjectImageUrl = prop => {
    if (!prop.images || prop.images.length === 0) {
      return '/uploads/properties/no-image.jpg';
    }
    console.log(prop);
    const image = prop.images[0];
    const entityType = 'projects';
    return getImageUrl(image, entityType, prop.id);
  };

  return (
    <Col xs={12}>
      <Card
        className="bg-white"
        style={{
          borderLeft: `5px solid var(--falcon-lighten-${classNames({
            success: project.status === 'Activa',
            warning: project.status === 'Pausada',
            primary: project.status === 'Finalizada',
            secondary: project.status === 'Pendiente',
            danger: project.status === 'Eliminada'
          })})`
        }}
      >
        <Card.Body>
          <Row className="g-3">
            <Col xs={12} lg={6} className="d-flex">
              <Row className="g-3">
                <Col xs={12} lg={1} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    onChange={HandleCheckbox}
                    name={project.id}
                    checked={
                      selected.find(prop => prop.id === project.id) || false
                    }
                  />
                </Col>

                <Col xs={12} lg={4}>
                  {project.images?.length ? (
                    <Row className="g-2">
                      <Col
                        xs={12}
                        sm={6}
                        md={12}
                        style={{ maxHeight: '200px' }}
                      >
                        {project.images[0] && (
                          <img
                            src={getProjectImageUrl(project)}
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}
                          />
                        )}
                      </Col>

                      {project.images[1] && (
                        <Col
                          className="d-none d-sm-inline d-md-none"
                          style={{ maxHeight: '200px' }}
                        >
                          <img
                            src={
                              project.images[1].url
                                ? project.images[1].url
                                : `${process.env.REACT_APP_CLIENT}/uploads/projects/${project.images[1].filename}`
                            }
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}
                          />
                        </Col>
                      )}
                    </Row>
                  ) : (
                    <Image src="https://via.placeholder.com/150" fluid />
                  )}
                </Col>

                <Col xs={12} lg={7}>
                  <p
                    className={classNames('d-block fw-bold m-0', {
                      'mb-1': loading
                    })}
                  >
                    {project.title.length > 50
                      ? `${project.title.substring(0, 47)}...`
                      : project.title}
                  </p>

                  <p className="d-block small mb-2">
                    Tipo: <strong>{project.type}</strong>
                  </p>

                  <p className="d-block small mb-2">
                    Dirección:{' '}
                    <strong>
                      {project.address}, {project.barrios}
                    </strong>
                  </p>

                  <p className="d-block small mb-3">
                    Unidades: <strong>{project.rawProp?.units?.length}</strong>
                  </p>

                  <p
                    className={classNames('d-block m-0', {
                      'mb-1': loading
                    })}
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    Precio:{' '}
                    <strong>
                      {price?.min || price?.max
                        ? `${currObj[price?.min?.currency]} ${
                            price?.min?.amount
                          } -\n${currObj[price?.max?.currency]} ${
                            price?.max?.amount
                          }`
                        : '-'}
                    </strong>
                  </p>

                  <p
                    className={classNames('d-block m-0', {
                      'mb-1': loading
                    })}
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    Superficie:{' '}
                    <strong>
                      {surface?.min || surface?.max
                        ? `${surface?.min}m2 - ${surface?.max}m2`
                        : '-'}
                    </strong>
                  </p>

                  <hr className="my-2" />

                  <span
                    className={classNames(
                      'd-flex justify-content-between align-items-center',
                      {
                        'mb-1': loading
                      }
                    )}
                  >
                    <div className="d-flex align-items-center gap-1">
                      <BiBuildings />
                      <p className="m-0">
                        <strong> Datos generales</strong>
                      </p>
                    </div>

                    <FiInfo
                      className="fs-1"
                      onClick={() => setOpenInfoModal(true)}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>

                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Nombre de la constructora:{' '}
                    <strong>{project.builder?.name}</strong>
                  </p>

                  <p className="d-block small m-0">
                    Fecha de entrega:{' '}
                    <strong>{project.builder?.deadline}</strong>
                  </p>
                </Col>
              </Row>
            </Col>

            <Col xs={12} lg={6}>
              <Row className="mb-4">
                <Col>
                  <Row>
                    <Col>
                      <span className="d-flex align-items-center">
                        <FiActivity className="me-1" />{' '}
                        <p className="m-0">
                          <strong>Actividad</strong>
                        </p>
                      </span>
                    </Col>

                    <Col className="d-flex justify-content-end">
                      <p className="m-0">
                        {project.share?.active && project.share.percent ? (
                          <span>
                            <span>Honorarios: </span>

                            <SoftBadge bg="primary" className="mt-2 me-2">
                              {project.share.percent} %
                            </SoftBadge>
                          </span>
                        ) : null}
                        <span> Estado: </span>

                        <SoftBadge
                          bg={classNames({
                            success: project.status === 'Activa',
                            warning: project.status === 'Pausada',
                            primary: project.status === 'Finalizada',
                            danger: project.status === 'Eliminada',
                            secondary:
                              project.status !== 'Activa' &&
                              project.status !== 'Pausada' &&
                              project.status !== 'Finalizada' &&
                              project.status !== 'Eliminada'
                          })}
                        >
                          <strong>{project.status}</strong>
                        </SoftBadge>
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="g-3">
                <Col xs={4} className="border-end">
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Visualizaciones{' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`tooltip-top`} className="small">
                          Visualizaciones de la propiedad en el sitio web en el
                          último mes.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FiInfo />
                      </span>
                    </OverlayTrigger>
                  </p>
                  <p className="d-block m-0">
                    {project.statistics?.views || 0}
                  </p>
                </Col>

                <Col xs={4} className="border-end">
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Interesados{' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`tooltip-top`} className="small">
                          Interesados de la propiedad en el sitio web en el
                          último mes.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FiInfo />
                      </span>
                    </OverlayTrigger>
                  </p>
                  <p className="d-block m-0">
                    {project.statistics?.favorites || 0}
                  </p>
                </Col>

                <Col xs={4}>
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Consultas{' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`tooltip-top`} className="small">
                          Consultas de la propiedad en el sitio web en el último
                          mes.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FiInfo />
                      </span>
                    </OverlayTrigger>
                  </p>
                  <p className="d-block m-0">
                    {project.statistics?.conversations || 0}{' '}
                    {!loading && (
                      <Link className="small" to="/mensajes">
                        Ver consultas
                      </Link>
                    )}
                  </p>
                </Col>

                <Col xs={12}>
                  <StepsStatus project={project.rawProp} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>

        <Card.Footer
          style={{ zIndex: 2 }}
          className="border-top d-sm-flex justify-content-between align-items-end"
        >
          <div className="d-md-flex">
            <p className="m-1">
              <small className="text-muted">
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={<Tooltip>{project.id}</Tooltip>}
                >
                  <span>
                    <strong>ID</strong>
                  </span>
                </OverlayTrigger>
              </small>
            </p>

            <p className="m-1">
              <small className="text-muted">
                <strong> Fecha de creación:</strong>{' '}
                {project.created_at.split(' ')[0]}
              </small>
            </p>

            <p className="m-1">
              <small className="text-muted">
                <strong> Última actualización:</strong> {project.updated_at}
              </small>
            </p>

            <p className="m-1">
              <small className="text-muted">
                <strong>Compartido:</strong>{' '}
                {project.share?.active && project.share.percent
                  ? `${project.share.percent}%`
                  : 'No'}
              </small>
            </p>
          </div>

          <div className="text-end">{project.actions}</div>
        </Card.Footer>
      </Card>

      <InfoBuilderModal
        setShow={setOpenInfoModal}
        show={openInfoModal}
        builder={project.builder}
      />
    </Col>
  );
};

ProjectListItem.propTypes = {
  project: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  selected: PropTypes.array,
  setSelected: PropTypes.func
};

export default ProjectListItem;
